import { type UseTranslationOptions, useTranslation } from "react-i18next";

interface Props extends Omit<UseTranslationOptions<string>, "keyPrefix"> {
  namespace?: string;
}

/**
 * Use this hook instead of useTranslation as we don't use namespaces
 * this is less bulky to write as we mainly use the keyPrefix
 * @param keyPrefix
 * @param props
 * @returns
 */
const useAppTranslation = (keyPrefix?: string, props?: Props) => {
  const { namespace, ...rest } = props ?? {};
  return useTranslation(namespace, { keyPrefix, ...rest });
};

export default useAppTranslation;
